<template>
	<table-paginator :data="orders" @pagechange="$emit('pagechange', $event)">
		<hr />
		<b-list-group flush v-for="(row, index) in orders.data">
			<b-list-group-item
				:key="index"
				class="px-2 py-2"
				href=""
				v-on:click="handleRowClick(row)"
			>
				<div class="d-flex justify-content-between">
					<b-col cols="10" class="px-0">
						<template v-if="row.unidentified_client == 0">
							<avatar
								inline
								color="#fff"
								:size="30"
								:username="row.name"
								:initials="row.name.slice(0, 1)"
							></avatar>
							<span style="margin-left: 10px"
								>{{ row.name }}
								<a
									class="btn btn-link text-success"
									@click.stop
									v-if="row.phone_wa != null"
									:href="getWhatsAppLink(row)"
									target="_blank"
									><i class="fab fa-lg fa-whatsapp"></i
								></a>
							</span>
						</template>
						<template v-else>
							<avatar
								inline
								color="#fff"
								:size="30"
								:username="'Consumidor Final'"
								:initials="'VA'"
							></avatar>
							<span style="margin-left: 10px">Venda à vista</span>
						</template>
					</b-col>
					<b-col cols="2" class="text-right pr-1">
						<b-dropdown
							variant="light"
							dropleft
							:boundary="'window'"
							toggle-class="text-decoration-none"
							no-caret
							v-if="row.status !== 'c'"
						>
							<template v-slot:button-content>
								<i class="fas fa-ellipsis-v text-muted" />
							</template>
							<b-dropdown-item
								v-if="row.finance_status == 1 && row.status == 'o'"
								@click.stop="$emit('PrintOrder', row)"
							>
								<i class="fas fa-print" />
								Imprimir Venda
							</b-dropdown-item>
							<b-dropdown-item
								v-if="row.status == 'p'"
								@click.stop="$emit('PrintOrder', row)"
							>
								<i class="fas fa-print" />
								Imprimir Orçamento
							</b-dropdown-item>
							<b-dropdown-item @click.stop="printOrder(row)" disabled>
								<i class="fas fa-print" />
								Imprimir Rascunho
							</b-dropdown-item>

							<template v-if="canEmitNfe(row)">
								<b-dropdown-divider></b-dropdown-divider>
								<b-dropdown-item
									@click.stop="
										$emit('emitNfe', {
											id: row.id,
											value_nf: row.net_total,
											model: 55
										})
									"
								>
									<i class="fas fa-file-invoice" />
									Emitir NF-e
								</b-dropdown-item>
								<b-dropdown-item
									@click.stop="
										$emit('emitNfe', {
											id: row.id,
											value_nf: row.net_total,
											model: 65
										})
									"
								>
									<i class="fas fa-receipt" />
									Emitir NFc-e
								</b-dropdown-item>
							</template>

							<template
								v-if="
									row.finance_status !== 1 &&
										row.status == 'o' &&
										orderCreateEdit
								"
							>
								<b-dropdown-divider></b-dropdown-divider>
								<b-dropdown-item @click.stop="$emit('EmitOrderBill', row.id)">
									<i class="fas fa-cash-register" />
									Lançar Contas
								</b-dropdown-item>
							</template>

							<template
								v-if="
									row.status == 'o' &&
										enabledStock &&
										row.stock_status == 0 &&
										orderCreateEdit
								"
							>
								<b-dropdown-item
									@click.stop="$emit('emitMovimentStock', row.id)"
								>
									<i class="fas fa-box" />
									Lançar Estoque
								</b-dropdown-item>
							</template>

							<template
								v-if="
									row.status == 'o' && row.operation_id == 1 && orderCreateEdit
								"
							>
								<b-dropdown-divider></b-dropdown-divider>
								<b-dropdown-item
									@click.stop="handleCreateReturningFrom(row.id)"
								>
									<i class="fas fa-undo-alt" />
									Devolver produtos
								</b-dropdown-item>
							</template>

							<template v-if="row.status !== 'c' && orderCancel">
								<b-dropdown-divider></b-dropdown-divider>
								<b-dropdown-item @click.stop="$emit('CancelOrder', row)">
									<i class="fas fa-ban text-danger" />
									Cancelar
								</b-dropdown-item>
							</template>
						</b-dropdown>
					</b-col>
				</div>
				<div class="d-flex justify-content-between py-3">
					<b-col cols="9" class="px-0">
						<small>{{ row.saved_at | dateTimeBr }}</small>
					</b-col>
					<b-col class="text-right px-0">
						<b>{{ row.net_total | decimal }}</b>
					</b-col>
				</div>

				<div class="d-flex justify-content-between mt-2">
					<b-col cols="9" class="px-0">
						<p class="text-sm mb-0">
							<i
								class="fas fa-dollar-sign text-success"
								style="margin-rigth: 5px"
							></i>
							<i
								class="fas fa-sm fa-check text-primary"
								style="margin-rigth: 5px"
								v-if="row.finance_status == 1"
							></i>
							<i
								class="fas fa-sm fa-times text-danger"
								style="margin-rigth: 5px"
								v-if="row.finance_status == 0"
							></i
							>&nbsp;&nbsp;

							<i
								class="fas fa-cubes text-success"
								style="margin-rigth: 5px"
							></i>
							<i
								class="fas fa-sm fa-check text-primary"
								style="margin-rigth: 5px"
								v-if="row.stock_status == 1"
							></i>
							<i
								class="fas fa-sm fa-times text-danger"
								style="margin-rigth: 5px"
								v-if="row.stock_status == 0"
							></i>
						</p>
					</b-col>

					<b-col class="text-right px-0 col">
						<order-status-badge :order="row" />
					</b-col>
				</div>
				<hr />
			</b-list-group-item>
		</b-list-group>
	</table-paginator>
</template>

<script>
	import PrRow from "../printers/grid/PrRow";
	import TablePaginator from "./../sections/TablePaginator.vue";
	import Avatar from "vue-avatar";
	import OrderStatusBadge from "@/components/sections/order/OrderStatusBadge";

	export default {
		components: {
			PrRow,
			TablePaginator,
			Avatar,
			OrderStatusBadge,
		},

		props: {
			orders: {},
		},

		data: () => ({
			operations: {
				1: {
					path: "venda",
				},

				2: {
					path: "devolucao",
				},
			},
		}),

		computed: {
			enabledStock() {
				if (this.$store.state.company.module_stock_active == 1) {
					return true;
				}
			},

			hasModuleNfe() {
				if (!this.$store.state.user) {
					return false;
				}

				if (this.$store.state.user.master_user_id != 3) {
					return false;
				}

				return true;
			},
			orderCancel() {
				return this.$acl.can('orderCancel')
			},
			orderCreateEdit() {
				return this.$acl.can('orderCreateEdit')
			}
		},

		methods: {
			canEmitNfe(row) {
				return row.operation_id == 1;
			},

			handleRowClick(row) {
				this.$router.push(
					"/vendas/" +
					this.operations[row.operation_id].path +
					"/editar/" +
					row.id
				);
			},

			handleCreateReturningFrom(id) {
				this.$router.push("/vendas/devolucao/novo?fromOrder=" + id);
			},

			getWhatsAppLink(orders) {
				let name = orders.name.replace(/ .*/, "");
				let link = "https://api.whatsapp.com/send?phone=+55" + orders.phone_wa;
				let msg =
					"&text=Olá " + name + ", Gostariamos de agradecer por comprar conosco!";

				return link + msg;
			},
		},
	};
</script>

<style>
</style>
